import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { useState } from 'react';
import { ThemeProvider } from './theme/ThemeProvider.jsx';
import { AuthProvider, useAuth } from './hooks/useAuth.js';
import { useUserPreferences, UserPreferencesProvider } from './hooks/useUserPreferences.js';
import Login from './pages/auth/Login.jsx';
import ForgotPassword from './pages/auth/ForgotPassword.jsx';
import ResetPassword from './pages/auth/ResetPassword.jsx';
import Cockpit from './pages/cockpit/Cockpit.jsx';
import ListagemUsuarios from './pages/usuario/ListagemUsuarios.jsx';
import CadastroUsuario from './pages/usuario/CadastroUsuario.jsx';
import DadosEmpresa from './pages/empresa/DadosEmpresa.jsx';
import ListagemModulos from './pages/modulo/ListagemModulos.jsx';
import CadastroModulo from './pages/modulo/CadastroModulo.jsx';
import ListagemAuditoria from './pages/auditoria/ListagemAuditoria.jsx';
import PreferenciasUsuario from './pages/usuario/PreferenciasUsuario.jsx';
import MenuLateral from './components/MenuLateral.jsx';
import Header from './components/Header.jsx';
import PreferencesLoader from './components/PreferencesLoader.jsx';
import ChatPage from './pages/chat/ChatPage.jsx';
import ListagemBeneficiarios from './pages/beneficiarios/ListagemBeneficiarios.jsx';
import ListagemRepresentantes from './pages/representantes/ListagemRepresentantes.jsx';
import AtribuirRepresentante from './pages/atribuirrepresentante/AtribuirRepresentante.jsx';
import ListaPlanos from './pages/planos/ListaPlanos.jsx';
import ListaParceiros from './pages/parceiros/ListaParceiros.jsx';
import ListaContratos from './pages/contratos/ListaContratos.jsx';
import NovoContrato from './pages/contratos/NovoContrato.jsx';
import MinhasComissoes from './pages/minhascomissoes/MinhasComissoes.jsx';
import GestaoComissoes from './pages/gestaocomissoes/GestaoComissoes.jsx';
import ConfiguracaoContratos from './pages/configuracoes/ConfiguracaoContratos.jsx';

function PrivateRoute({ children }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      Carregando...
    </Box>;
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
}

function AppLayout() {
  const [menuOpen, setMenuOpen] = useState(true);
  const { menuPosition } = useUserPreferences();

  const toggleMenu = () => {
    setMenuOpen(prev => !prev);
  };

  const isLeft = menuPosition === 'left';

  return (
    <Box sx={{ display: 'flex', height: '100vh', flexDirection: 'column' }}>
      <PreferencesLoader />
      {/* Cabeçalho */}
      <Header menuOpen={menuOpen} onToggleMenu={toggleMenu} />

      {/* Conteúdo Principal */}
      <Box sx={{ display: 'flex', flex: 1, overflow: 'hidden', mt: { xs: '56px', sm: '64px' } }}>
        {/* Menu na Esquerda */}
        {isLeft && <MenuLateral open={menuOpen} onToggle={toggleMenu} anchor="left" />}

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            overflow: 'auto',
            position: 'relative',
            backgroundColor: 'background.default',
          }}
        >
          <Outlet />
        </Box>

        {/* Menu na Direita (Padrão) */}
        {!isLeft && <MenuLateral open={menuOpen} onToggle={toggleMenu} anchor="right" />}
      </Box>
    </Box>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      {/* Rotas Protegidas com Layout Persistente */}
      <Route element={
        <PrivateRoute>
          <AppLayout />
        </PrivateRoute>
      }>
        <Route path="/cockpit" element={<Cockpit />} />
        <Route path="/empresas" element={<DadosEmpresa />} />
        <Route path="/usuarios" element={<ListagemUsuarios />} />
        <Route path="/usuarios/cadastro" element={<CadastroUsuario />} />
        <Route path="/usuarios/editar/:id" element={<CadastroUsuario />} />
        <Route path="/modulos" element={<ListagemModulos />} />
        <Route path="/modulos/cadastro" element={<CadastroModulo />} />
        <Route path="/modulos/editar/:id" element={<CadastroModulo />} />
        <Route path="/modulos/editar/:id" element={<CadastroModulo />} />
        <Route path="/preferencias" element={<PreferenciasUsuario />} />
        <Route path="/auditoria" element={<ListagemAuditoria />} />


        <Route path="/beneficiarios" element={<ListagemBeneficiarios />} />
        <Route path="/planos" element={<ListaPlanos />} />
        <Route path="/parceiros" element={<ListaParceiros />} />
        <Route path="/contratos" element={<ListaContratos />} />
        <Route path="/contratos/novo" element={<NovoContrato />} />
        <Route path="/minhascomissoes" element={<MinhasComissoes />} />
        <Route path="/gestaocomissoes" element={<GestaoComissoes />} />
        <Route path="/representantes" element={<ListagemRepresentantes />} />
        <Route path="/atribuirrepresentante" element={<AtribuirRepresentante />} />
        <Route path="/ajustar-contrato" element={<ConfiguracaoContratos />} />
        <Route path="/chat" element={<ChatPage />} />

        {/* Rota padrão logada */}
        <Route path="/" element={<Navigate to="/cockpit" />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <UserPreferencesProvider>
            <AppRoutes />
          </UserPreferencesProvider>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;

